import React, { Component } from 'react';
import { connect } from 'react-redux';
import className from 'classnames';
import formatDate from '../../modules/formatDate';
import totalBaseAndSVCFee from '../../selectors/totalBaseAndSVCFee.selector';
import totalBaseAndSVCFeeString from '../../selectors/totalBaseAndSVCFeeString.selector';
import TextInput from '../../components/TextInput';

class TotalBaseAndSVCFee extends Component {
  constructor(props) {
    super(props);
    this.shouldShowPurchaseDate = this.shouldShowPurchaseDate.bind(this);
  }

  shouldShowPurchaseDate() {
    const now = formatDate(new Date());
    const purchased = formatDate(this.props.today);
    return now === purchased;
  }

  render() {
    const { totalBaseAndSVCFee, totalBaseAndSVCFeeString, monthsFromNow } = this.props;

    const noprint = className({
      'Row': true,
      'print-only': !this.shouldShowPurchaseDate(),
      'no-print': this.shouldShowPurchaseDate(),
    });

    return (
      <div>
        <div className={noprint}>
          <TextInput tabIndex="-1" className="Row-total print-only" value={formatDate(this.props.today)} readOnly />
          <b className="print-label print-only">Purchase Date</b>
        </div>
        <div className="Row">
          <TextInput tabIndex="-1" className="Row-total" data-id="totalBaseAndSVCFee" id="Rsub1a" tooltip="Registration fees (Total State &amp; County)" value={totalBaseAndSVCFee} readOnly />
          <span id="totalBaseAndSVCFeeString" dangerouslySetInnerHTML={{ __html: totalBaseAndSVCFeeString }} />
          <input id="monthset" value={monthsFromNow} readOnly className="u-hidden" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    totalBaseAndSVCFee: totalBaseAndSVCFee(state),
    monthsFromNow: state.registration.monthsFromNow,
    totalBaseAndSVCFeeString: totalBaseAndSVCFeeString(state),
    selectedMonthNumber: state.registration.selectedMonthNumber,
    today: state.registration.today,
  };
};

export default connect(mapStateToProps)(TotalBaseAndSVCFee);
